import type { UseQueryResult } from "@tanstack/react-query";

type GetPendingMessageParams = {
	isFetching: UseQueryResult["isFetching"];
	failureReason: UseQueryResult["failureReason"];
	failureCount: UseQueryResult["failureCount"];
	pendingMessage: string;
};

const getPendingMessage = ({ isFetching, failureCount, failureReason, pendingMessage }: GetPendingMessageParams) => {
	if (isFetching) {
		if (failureReason) {
			const getReason = () => {
				if (failureReason.message.includes("500")) {
					return "server hlásí problém";
				}

				if (failureReason.message.includes("404")) {
					return "nemůžu najít požadované výsledky";
				}

				return "něco se pokazilo";
			};

			return `${getReason()}, zkouším načíst znovu (${failureCount}. pokus)`;
		}

		return pendingMessage;
	}

	return;
};

export default getPendingMessage;
